import * as React from 'react';
import { Button, Icon } from '@teamsnap/teamsnap-ui';

interface TagsProps {
  tags?: any;
  icon?: React.ReactNode;
  key?: string;
  mappedKey?: string;
  onChange: (tag: string) => void;
  placeholder: string;
  subLabel?: string;
}

interface TagProps {
  name: string;
  key: string;
}

const Tag = ({ name, key }: TagProps) => (
  <span
    className="u-padSidesMd u-padEndsSm u-spaceRightSm u-bgWhite u-fontSizeLg"
    key={key}
    style={{
      borderRadius: 5,
      border: '1px solid #DCE1E7',
    }}
  >
    <span className="u-spaceRightMd">{name}</span>

    <Icon
      name="dismiss"
      style={{
        height: 16,
        width: 16,
      }}
    />
  </span>
);

const Tags = ({ tags, icon, mappedKey, onChange, placeholder, subLabel }: TagsProps) => {
  const [value, setValue] = React.useState<string>('');

  const displayGroups = () => tags.map((tag, idx) => <Tag name={tag[mappedKey]} key={`${idx}-${tag[mappedKey]}`} />);

  const handleOnChange = (event) => {
    setValue(event.target.value);
  };

  const handleKeyEvent = (event) => {
    if (event.key === 'Enter') {
      setValue('');
      onChange(value);
    }
  };

  return (
    <>
      <div className="u-flex u-flexRow" data-testid="tags-component">
        <div
          style={{
            borderRadius: 5,
            border: '1px solid #DCE1E7',
          }}
          className="u-flexAlignItemsCenter u-bgWhite u-padSidesMd u-size3of4 u-spaceRightSm"
        >
          <div>
            {icon}

            <input
              data-testid="tags-component-input"
              className="u-sizeFull u-borderNone u-fontSizeLg u-padEndsMd u-bgWhite"
              type="text"
              value={value}
              placeholder={placeholder}
              onChange={handleOnChange}
              onKeyDown={handleKeyEvent}
            />
          </div>
        </div>

        <div className="u-size1of4" style={{ cursor: 'pointer' }}>
          <Button
            style={{ height: 56 }}
            color="primary"
            size="large"
            testId='tags-component-button'
            onClick={() => {
              setValue('');
              onChange(value);
            }}
          >
            Enter
          </Button>
        </div>
      </div>

      {subLabel ? (
        <div>
          <p className="helper u-spaceTopXs">{subLabel}</p>
        </div>
      ) : null}

      {tags ? <div className="u-spaceTopLg">{displayGroups()}</div> : null}
    </>
  );
};

Tags.defaultProps = {
  tags: [],
  icon: null,
  key: 0,
  mappedKey: 'name',
  subLabel: null,
};

export default Tags;
